import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@companion-core/shared/app/Components/Button";
import { useWebNavigationHeader } from "@companion-core/web/src/Hooks/navigationHeader";
import "@companion-core/web/src/Assets/Styles/scss/errors.scss";

export const NotFound = () => {
  const { t } = useTranslation();
  const { navigateBackward } = useWebNavigationHeader();

  return (
    <div className="error__container">
      <img className="error__image" src="/assets/images/error/not_found_error.svg" />
      <div className="body-text-3 error__title">{t("common.error.404.title")}</div>
      <div className="body-text-4 margin-top-24">{t("common.error.404.text")}</div>
      <Button
        classNames={["error__button"]}
        testID="error-not-found__button"
        label={t("common.error.404.button")}
        onClick={() => navigateBackward()}
      />
    </div>
  );
};
